<template>
    <div class="index-wrap">
        <div class="firstParClass">
            <div class="wordClassTwoMain">合&nbsp;作&nbsp;机&nbsp;构</div>
            <div class="wordClassTwoMainChild">满分运动与全国近百所中小学开展合作</div>
        </div>
        <div style="background: #F1F1F1;width: 100%;height: 150px;position: relative">
            <div class="wordClassThreeChild">合作院校</div>
            <div class="wordClassThreeChildLine"></div>
        </div>

        <div style="width: 8000%;height: 800px;overflow: hidden;background: #F7F7F7;">
            <vueSeamlessScroll :data="oneList" :class-option="optionLeftOne">
                <ul>
                    <li class="liClass" v-for="(item, index) in oneList" :key='index'>
                        <div class="liDivClass">
                            <div style="position: relative">
                                <img :src="item.imgLogo"
                                     style="height: 110px;transform: translate(-50%, -50%);left: 67px;top:108px;position: absolute;">
                                <img :src="item.imgSchool"
                                     style="height: 167px;transform: translate(-50%, -50%);left: 292px;top:111px;position: absolute;">
                                <div style="width:320px;text-align: center;position: absolute;transform: translate(-50%, -50%);left: 50%;top:220px;font-size: 18px;font-family: Source Han Sans CN;font-weight: 400;color: #4C4C4C;line-height: 10px;">
                                    {{item.nameSchool}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </vueSeamlessScroll>
            <vueSeamlessScroll :data="twoList" :class-option="optionLeftTwo">
                <ul>
                    <li class="liClass" v-for="(item, index) in twoList" :key='index'>
                        <div class="liDivClass">
                            <div style="position: relative">
                                <img :src="item.imgLogo"
                                     style="height: 110px;transform: translate(-50%, -50%);left: 67px;top:108px;position: absolute;">
                                <img :src="item.imgSchool"
                                     style="height: 167px;transform: translate(-50%, -50%);left: 292px;top:111px;position: absolute;">
                                <div style="width:320px;text-align: center;position: absolute;transform: translate(-50%, -50%);left: 50%;top:220px;font-size: 18px;font-family: Source Han Sans CN;font-weight: 400;color: #4C4C4C;line-height: 10px;">
                                    {{item.nameSchool}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </vueSeamlessScroll>
            <vueSeamlessScroll :data="threeList" :class-option="optionLeftThree">
                <ul>
                    <li class="liClass" v-for="(item, index) in threeList" :key='index'>
                        <div class="liDivClass">
                            <div style="position: relative">
                                <img :src="item.imgLogo"
                                     style="height: 110px;transform: translate(-50%, -50%);left: 67px;top:108px;position: absolute;">
                                <img :src="item.imgSchool"
                                     style="height: 167px;transform: translate(-50%, -50%);left: 292px;top:111px;position: absolute;">
                                <div style="width:320px;text-align: center;position: absolute;transform: translate(-50%, -50%);left: 50%;top:220px;font-size: 18px;font-family: Source Han Sans CN;font-weight: 400;color: #4C4C4C;line-height: 10px;">
                                    {{item.nameSchool}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </vueSeamlessScroll>
        </div>

        <div style="background: #EBEBEB;width: 100%;height: 150px;position: relative">
            <div class="wordClassThreeChild">战略合作伙伴</div>
            <div class="wordClassThreeChildLine"></div>
        </div>
        <div style="height: 400px;position: relative;background: #EBEBEB">
            <div
                    style="height:400px; width: 70%;transform: translate(-50%, -50%);left: 50%;top:60%;position: absolute;font-size: 0;">
                <div id="left"
                     style="height: 265px;margin-left:3%;width: 28%;background: #FCFCFC;position: relative;box-shadow: 0px 0px 38px 2px rgba(34,34,34,0.15);opacity: 1;border-radius: 10px;">
                    <img src="../assets/pageThree/partnerLogoOne.png"
                         style="position: absolute;top: 50%;left:50%;transform: translate(-50%, -50%);height: 170px"/>
                </div>
                <div id="middle"
                     style="height: 265px;margin-left:5%;width: 28%;background: #FCFCFC;position: relative;box-shadow: 0px 0px 38px 2px rgba(34,34,34,0.15);opacity: 1;border-radius: 10px;">
                    <img src="../assets/pageThree/partnerLogoTwo.png"
                         style="position: absolute;top: 50%;left:50%;transform: translate(-50%, -50%);height: 170px"/>
                </div>
                <div id="right"
                     style="height: 265px;margin-left:5%;width: 28%;background: #FCFCFC;position: relative;box-shadow: 0px 0px 38px 2px rgba(34,34,34,0.15);opacity: 1;border-radius: 10px;">
                    <img src="../assets/pageThree/partnerLogoThree.png"
                         style="position: absolute;top: 50%;left:50%;transform: translate(-50%, -50%);height: 170px"/>
                </div>
            </div>
        </div>

        <div style="background: #EBEBEB;width: 100%;height: 150px;position: relative">
            <div class="wordClassThreeChild">科研合作机构</div>
            <div class="wordClassThreeChildLine"></div>
        </div>
        <div style="height: 730px;position: relative;background: #EBEBEB;">
            <div style="background:white;height:670px; width: 80%;min-width: 1000px; transform: translate(-50%, -50%);left: 50%;top:50%;position: absolute;box-shadow: 0px 0px 38px 2px rgba(34,34,34,0.15);opacity: 1;border-radius: 10px;">
                <div id="part1" style="position: relative">
                    <img src="../assets/pageThree/logoOne.png"
                         style="position: absolute;top: 44%;left:50%;transform: translate(-50%, -50%);">
                    <div style="text-align: center;font-family:Source Han Sans CN;font-weight: bold;color: rgb(34, 34, 34);top: 74%;left: 50%;transform: translate(-50%, -50%);position: absolute;font-size: 32px;width: 456px;">
                        北京大学妇女儿童体育研究中心
                    </div>
                    <div style="position: absolute;top: 312px;height: 1px;width: 489px;transform: translate(-50%, -50%);left: 50%;background: rgb(207, 207, 207);"></div>
                </div>
                <!--        <div style="position: absolute;top: 343px;height: 1px;width: 531px;transform: translate(-50%, -50%);left: 207px;background: #CFCFCF;"></div>-->
                <div style="border-right: 1px solid #CFCFCF;height: 230px;float: left;position: absolute;transform: translate(-50%, -50%);left: 50%;top:24%"></div>
                <div id="part2" style="position: relative;">
                    <img src="../assets/pageThree/logoTwo.png"
                         style="position: absolute;top: 46%;left:50%;transform: translate(-50%, -50%);height: 69px">
                    <div style="text-align: center;font-family:Source Han Sans CN;font-weight: bold;color: rgb(34, 34, 34);top: 74%;left: 50%;transform: translate(-50%, -50%);position: absolute;font-size: 32px;width: 456px;">
                        北京大学信息技术高等研究院
                    </div>
                    <div style="position: absolute;top: 312px;height: 1px;width: 489px;transform: translate(-50%, -50%);left: 50%;background: rgb(207, 207, 207);"></div>
                </div>

                <div id="part3" style="position: relative">
                    <img src="../assets/pageThree/logoThree.png"
                         style="position: absolute;top: 46%;left:50%;transform: translate(-50%, -50%);height: 69px">
                    <div style="text-align: center;font-family:Source Han Sans CN;font-weight: bold;color: rgb(34, 34, 34);top: 74%;left: 50%;transform: translate(-50%, -50%);position: absolute;font-size: 32px;width: 456px;">
                        首都体育学院
                    </div>
                </div>
                <div style="border-right: 1px solid #CFCFCF;height: 230px;float: left;position: absolute;transform: translate(-50%, -50%);left: 50%;top:68%"></div>
                <div id="part4" style="position: relative">
                    <img src="../assets/pageThree/logoFour.png"
                         style="position: absolute;top: 46%;left:50%;transform: translate(-50%, -50%);height: 69px">
                    <div style="text-align: center;font-family:Source Han Sans CN;font-weight: bold;color: rgb(34, 34, 34);top: 74%;left: 50%;transform: translate(-50%, -50%);position: absolute;font-size: 32px;width: 456px;">
                        北京市海淀区教育科学研究院
                    </div>
                </div>
            </div>
        </div>

        <div style="height: 10px;width: 100%;"></div>

    </div>
</template>

<script>
    import vueSeamlessScroll from 'vue-seamless-scroll'

    export default {
        components: {
            vueSeamlessScroll
        },
        data() {
            return {
                imgList: [],
                oneList: [
                  {imgLogo: require('../assets/schoolImg/01-人大附中西山学校.png'),imgSchool:require('../assets/schoolImg/01-人大附中西山学校1.png'),nameSchool:'人大附中西山学校'},
                  {imgLogo: require('../assets/schoolImg/02-人大附中石景山学校.png'),imgSchool:require('../assets/schoolImg/02-人大附中石景山学校1.png'),nameSchool:'人大附中石景山学校'},
                  {imgLogo: require('../assets/schoolImg/03-北京学校.png'),imgSchool:require('../assets/schoolImg/03-北京学校1.png'),nameSchool:'北京学校'},
                  {imgLogo: require('../assets/schoolImg/04-人大附中通州校区.png'),imgSchool:require('../assets/schoolImg/04-人大附中通州校区1.png'),nameSchool:'人大附中通州校区'},
                  {imgLogo: require('../assets/schoolImg/05-中国农业大学附属中学.png'),imgSchool:require('../assets/schoolImg/05-中国农业大学附属中学1.png'),nameSchool:'中国农业大学附属中学'},
                  {imgLogo: require('../assets/schoolImg/06-中国人民大学附属中学.png'),imgSchool:require('../assets/schoolImg/06-中国人民大学附属中学1.png'),nameSchool:'中国人民大学附属中学'},
                  {imgLogo: require('../assets/schoolImg/07-人大附中亦庄新城学校.png'),imgSchool:require('../assets/schoolImg/07-人大附中亦庄新城学校1.png'),nameSchool:'人大附中亦庄新城学校'},
                  {imgLogo: require('../assets/schoolImg/08-人大附中经济开发区学校.png'),imgSchool:require('../assets/schoolImg/08-人大附中经济开发区学校1.png'),nameSchool:'人大附中经济开发区学校'},
                  {imgLogo: require('../assets/schoolImg/09-北京十一晋元中学.png'),imgSchool:require('../assets/schoolImg/09-北京十一晋元中学1.png'),nameSchool:'北京十一晋元中学'},
                  {imgLogo: require('../assets/schoolImg/10-人大附中实验小学.png'),imgSchool:require('../assets/schoolImg/10-人大附中实验小学1.png'),nameSchool:'人大附中实验小学'},
                  {imgLogo: require('../assets/schoolImg/11-人大附中翠微学校.png'),imgSchool:require('../assets/schoolImg/11-人大附中翠微学校1.png'),nameSchool:'人大附中翠微学校'},
                  {imgLogo: require('../assets/schoolImg/12-北京市第十八中学(左安门校区).png'),imgSchool:require('../assets/schoolImg/12-北京市第十八中学(左安门校区)1.png'),nameSchool:'北京市第十八中学(左安门校区)'},
                  {imgLogo: require('../assets/schoolImg/13-北京钱学森中学.png'),imgSchool:require('../assets/schoolImg/13-北京钱学森中学1.png'),nameSchool:'北京钱学森中学'},
                  {imgLogo: require('../assets/schoolImg/14-北京市第十中学.png'),imgSchool:require('../assets/schoolImg/14-北京市第十中学1.png'),nameSchool:'北京市第十中学'},
                  {imgLogo: require('../assets/schoolImg/15-北京市宣武回民小学.png'),imgSchool:require('../assets/schoolImg/15-北京市宣武回民小学1.png'),nameSchool:'北京市宣武回民小学'},
                ],
                twoList: [
                  {imgLogo: require('../assets/schoolImg/16-北京第五实验学校.png'),imgSchool:require('../assets/schoolImg/16-北京第五实验学校1.png'),nameSchool:'北京第五实验学校'},
                  {imgLogo: require('../assets/schoolImg/17-北京十二中朗悦学校.png'),imgSchool:require('../assets/schoolImg/17-北京十二中朗悦学校1.png'),nameSchool:'北京十二中朗悦学校'},
                  {imgLogo: require('../assets/schoolImg/18-北京市八一学校.png'),imgSchool:require('../assets/schoolImg/18-北京市八一学校1.png'),nameSchool:'北京市八一学校'},
                  {imgLogo: require('../assets/schoolImg/19-中国农业大学附属小学.png'),imgSchool:require('../assets/schoolImg/19-中国农业大学附属小学1.png'),nameSchool:'中国农业大学附属小学'},
                  {imgLogo: require('../assets/schoolImg/20-清华大学附属中学永丰学校东校区.png'),imgSchool:require('../assets/schoolImg/20-清华大学附属中学永丰学校东校区1.png'),nameSchool:'清华大学附属中学永丰学校东校区'},
                  {imgLogo: require('../assets/schoolImg/21-红英小学(六里屯校区).png'),imgSchool:require('../assets/schoolImg/21-红英小学(六里屯校区)1.png'),nameSchool:'红英小学(六里屯校区)'},
                  {imgLogo: require('../assets/schoolImg/22-红英小学(冷泉学部).png'),imgSchool:require('../assets/schoolImg/22-红英小学(冷泉学部)1.png'),nameSchool:'红英小学(冷泉学部)'},
                  {imgLogo: require('../assets/schoolImg/23-红英小学(唐家岭校区).png'),imgSchool:require('../assets/schoolImg/23-红英小学(唐家岭校区)1.png'),nameSchool:'红英小学(唐家岭校区)'},
                  {imgLogo: require('../assets/schoolImg/24-红英小学(韩家川校区).png'),imgSchool:require('../assets/schoolImg/24-红英小学(韩家川校区)1.png'),nameSchool:'红英小学(韩家川校区)'},
                  {imgLogo: require('../assets/schoolImg/25-北京市第十中学(新疆校区).png'),imgSchool:require('../assets/schoolImg/25-北京市第十中学(新疆校区)1.png'),nameSchool:'北京市第十中学(新疆校区)'},
                  {imgLogo: require('../assets/schoolImg/26-人大附中朝阳分校东坝校区.png'),imgSchool:require('../assets/schoolImg/26-人大附中朝阳分校东坝校区1.png'),nameSchool:'人大附中朝阳分校东坝校区'},
                  {imgLogo: require('../assets/schoolImg/27-北京市海淀北部新区实验学校(小学部).png'),imgSchool:require('../assets/schoolImg/27-北京市海淀北部新区实验学校(小学部)1.png'),nameSchool:'北京市海淀北部新区实验学校(小学部)'},
                  {imgLogo: require('../assets/schoolImg/28-北京市海淀北部新区实验学校(初中部).png'),imgSchool:require('../assets/schoolImg/28-北京市海淀北部新区实验学校(初中部)1.png'),nameSchool:'北京市海淀北部新区实验学校(初中部)'},
                  {imgLogo: require('../assets/schoolImg/29-北京市第十八中学附属实验小学.png'),imgSchool:require('../assets/schoolImg/29-北京市第十八中学附属实验小学1.png'),nameSchool:'北京市第十八中学附属实验小学'},
                  {imgLogo: require('../assets/schoolImg/30-北京大学附属中学.png'),imgSchool:require('../assets/schoolImg/30-北京大学附属中学1.png'),nameSchool:'北京大学附属中学'},
                ],
                threeList: [
                  {imgLogo: require('../assets/schoolImg/31-北京邮电大学附属小学(今典校区).png'),imgSchool:require('../assets/schoolImg/31-北京邮电大学附属小学(今典校区)1.png'),nameSchool:'北京邮电大学附属小学(今典校区)'},
                  {imgLogo: require('../assets/schoolImg/32-翠湖小学(白水洼校区).png'),imgSchool:require('../assets/schoolImg/32-翠湖小学(白水洼校区)1.png'),nameSchool:'翠湖小学(白水洼校区)'},
                  {imgLogo: require('../assets/schoolImg/35-北京理工大学附属中学南校区.png'),imgSchool:require('../assets/schoolImg/35-北京理工大学附属中学南校区1.png'),nameSchool:'北京理工大学附属中学南校区'},
                  {imgLogo: require('../assets/schoolImg/36-北京理工大学附属中学东校区.png'),imgSchool:require('../assets/schoolImg/36-北京理工大学附属中学东校区1.png'),nameSchool:'北京理工大学附属中学东校区'},
                  {imgLogo: require('../assets/schoolImg/37-中国人民大学附属小学.png'),imgSchool:require('../assets/schoolImg/37-中国人民大学附属小学1.png'),nameSchool:'中国人民大学附属小学'},
                  {imgLogo: require('../assets/schoolImg/38-中国地质大学附属中学.png'),imgSchool:require('../assets/schoolImg/38-中国地质大学附属中学1.png'),nameSchool:'中国地质大学附属中学'},
                  {imgLogo: require('../assets/schoolImg/39-北京科技大学附属中学.png'),imgSchool:require('../assets/schoolImg/39-北京科技大学附属中学1.png'),nameSchool:'北京科技大学附属中学'},
                  {imgLogo: require('../assets/schoolImg/40-北京第七中学.png'),imgSchool:require('../assets/schoolImg/40-北京第七中学1.png'),nameSchool:'北京第七中学'},
                  {imgLogo: require('../assets/schoolImg/41-北京第二实验小学(新文化街校区).png'),imgSchool:require('../assets/schoolImg/41-北京第二实验小学(新文化街校区)1.png'),nameSchool:'北京第二实验小学(新文化街校区)'},
                  {imgLogo: require('../assets/schoolImg/42-北京第二实验小学(德胜校区).png'),imgSchool:require('../assets/schoolImg/42-北京第二实验小学(德胜校区)1.png'),nameSchool:'北京第二实验小学(德胜校区)'},
                  {imgLogo: require('../assets/schoolImg/B01-辽宁省实验学校.png'),imgSchool:require('../assets/schoolImg/B01-辽宁省实验学校1.png'),nameSchool:'辽宁省实验学校'},
                  {imgLogo: require('../assets/schoolImg/B02-辽宁省实验中学.png'),imgSchool:require('../assets/schoolImg/B02-辽宁省实验中学1.png'),nameSchool:'辽宁省实验中学'},
                  {imgLogo: require('../assets/schoolImg/B03-沈阳私立实验学校.png'),imgSchool:require('../assets/schoolImg/B03-沈阳私立实验学校1.png'),nameSchool:'沈阳私立实验学校'},
                  {imgLogo: require('../assets/schoolImg/C01-人大附中深圳学校.png'),imgSchool:require('../assets/schoolImg/C01-人大附中深圳学校1.png'),nameSchool:'人大附中深圳学校'},
                  {imgLogo: require('../assets/schoolImg/D01-杭州学军中学教育集团文渊中学.png'),imgSchool:require('../assets/schoolImg/D01-杭州学军中学教育集团文渊中学1.png'),nameSchool:'杭州学军中学教育集团文渊中学'},
                  {imgLogo: require('../assets/schoolImg/D02-萧山区江南初级中学.png'),imgSchool:require('../assets/schoolImg/D02-萧山区江南初级中学1.png'),nameSchool:'萧山区江南初级中学'},
                  {imgLogo: require('../assets/schoolImg/D03-盈丰小学.png'),imgSchool:require('../assets/schoolImg/D03-盈丰小学1.png'),nameSchool:'盈丰小学'},
                  {imgLogo: require('../assets/schoolImg/F01-合肥包河区协和双语学校.png'),imgSchool:require('../assets/schoolImg/F01-合肥包河区协和双语学校1.png'),nameSchool:'合肥包河区协和双语学校'},
                  {imgLogo: require('../assets/schoolImg/F02-合肥新华公学.png'),imgSchool:require('../assets/schoolImg/F02-合肥新华公学1.png'),nameSchool:'合肥新华公学'},
                  {imgLogo: require('../assets/schoolImg/F03-合肥上海世界外国语学校.png'),imgSchool:require('../assets/schoolImg/F03-合肥上海世界外国语学校1.png'),nameSchool:'合肥上海世界外国语学校'},
                ],
                oneStep: 1,
                twoStep: 10,
                threeStep: 1,
                timer:500
            }
        },
        computed: {
            optionLeftOne() {
                return {
                    step: this.oneStep, // 数值越大速度滚动越快
                    hoverStop: false, // 是否开启鼠标悬停stop
                    // openWatch: true, // 开启数据实时监控刷新dom
                    direction: 2, // 0向下 1向上 2向左 3向右
                    limitMoveNum: this.oneList.length, // 开始无缝滚动的数据量 this.dataList.length
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
                }
            },
            optionLeftTwo() {
                return {
                    step: this.twoStep, // 数值越大速度滚动越快
                    hoverStop: false, // 是否开启鼠标悬停stop
                    // openWatch: true, // 开启数据实时监控刷新dom
                    direction: 2, // 0向下 1向上 2向左 3向右
                    limitMoveNum: this.twoList.length, // 开始无缝滚动的数据量 this.dataList.length
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
                }
            },
            optionLeftThree() {
                return {
                    step: this.threeStep, // 数值越大速度滚动越快
                    hoverStop: false, // 是否开启鼠标悬停stop
                    // openWatch: true, // 开启数据实时监控刷新dom
                    direction: 2, // 0向下 1向上 2向左 3向右
                    limitMoveNum: this.threeList.length, // 开始无缝滚动的数据量 this.dataList.length
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
                }
            }
        },
        created() {
            // this.oneList = JSON.parse(JSON.stringify(this.imgList))//this.shuffle()//随机照片顺序
            // this.twoList = this.shuffle(JSON.parse(JSON.stringify(this.imgList)))//随机照片顺序
            // this.threeList = this.shuffle(JSON.parse(JSON.stringify(this.imgList)))//随机照片顺序
            this.startStep()//延迟开始运行动画
        },
        mounted() {
        },
        methods: {

            startStep() {
                let this_ = this
                setTimeout(function () {
                    //第一个setTimeout
                    this_.twoStep = 1
                    // setTimeout(function () {
                    //     //第二个setTimeout
                    //     this_.threeStep = 1
                    // }, this_.timer);
                }, this_.timer);
            },

            shuffle(list) {
                let res = [], random;
                while (list.length > 0) {
                    random = Math.floor(Math.random() * list.length)
                    res.push(list[random])
                    list.splice(random, 1)
                }
                return res
            }
            // sortList(){
            //     this.imgList.sort(function () {
            //         return Math.random() -0.5
            //     })
            // }
        }
    }
</script>

<style scoped>

    [v-cloak] {
        display: none;
    }

    .liClass {
        float: left;
        margin-right: 10px;
        padding: 15px 15px 15px 0px
    }

    .liDivClass {
        background: #F5F5F5;
        box-shadow: 0px 0px 38px 2px rgba(34, 34, 34, 0.15);
        opacity: 1;
        border-radius: 10px;
        width: 449px;
        height: 238px
    }

    /*.seamless-warp2 {*/
    /*    overflow: hidden;*/
    /*    height: 250px;*/
    /*    width: 380px;*/

    /*ul.item {*/
    /*    width: 580px;*/
    /*li {*/
    /*   */
    /*}*/

    /*}*/
    /*}*/

    #part1 {
        width: 50%;
        height: 300px;
        float: left;
    }

    #part2 {
        width: 49.9%;
        height: 300px;
        float: left;
    }

    #part3 { /* div 换行 */
        width: 50%;
        height: 300px;
        float: left;
        clear: left;
    }

    #part4 {
        width: 49.9%;
        height: 300px;
        float: left;
    }

    #left, #middle, #right {
        float: left;
        *display: inline;
        zoom: 1;
        vertical-align: top;
        font-size: 12px;
    }

    .firstParClass {
        position: relative;
        width: 100%;
        height: 625px;
        min-width: 500px;
        background-image: url('../assets/pageThree/mainBackThree.png');
        /*background-size: cover;*/
        background-size: 100% 100%;
        background-repeat: no-repeat;
        /*require('../assets/homeBack.png')*/
        /*shouye:'url(' + require('../../assets/images/shouye/index2x.png') + ')',*/
    }

    .wordClassThreeChild {
        position: absolute; /* 设置绝对定位子元素 */
        top: 26px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 48px;
        font-weight: bold;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #222222;
    }

    .wordClassTwoMain {
        position: absolute; /* 设置绝对定位子元素 */
        top: 226px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 78px;
        font-weight: 800;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #FFFFFF;
    }

    .wordClassTwoMainChild {
        position: absolute; /* 设置绝对定位子元素 */
        top: 360px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 37px;
        font-weight: 400;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #FFFFFF;
    }

    .wordClassThreeChildLine {
        position: absolute; /* 设置绝对定位子元素 */
        bottom: 42px; /* 将子元素底部与父元素底部对齐 */
        height: 4px;
        width: 79px;
        transform: translate(-50%, -50%);
        left: 50%;
        background: #F8DB00;
    }


</style>

<style scoped>
    .index-wrap {
        width: 100%;
        height: auto;
        /*  margin: 0 auto;*/
        overflow: hidden;
        position: relative;
    }

    .index-left-block h2 {
        background: #4fc08d;
        color: #fff;
        padding: 10px 15px;
        margin-bottom: 20px;
    }

    .index-left-block h3 {
        padding: 0 15px 5px 15px;
        font-weight: bold;
        color: #222;
    }

    .index-left-block ul {
        padding: 10px 15px;
    }

    .index-left-block li {
        padding: 5px;
    }


    .index-board-car .index-board-item-inner {
        /*background: url(../assets/images/1.png) no-repeat;*/
    }

    .index-board-loud .index-board-item-inner {
        /*background: url(../assets/images/2.png) no-repeat;*/
    }

    .index-board-earth .index-board-item-inner {
        /*background: url(../assets/images/3.png) no-repeat;*/
    }

    .index-board-hill .index-board-item-inner {
        /*background: url(../assets/images/4.png) no-repeat;*/
    }

    .index-board-item h2 {
        font-size: 18px;
        font-weight: bold;
        color: #000;
        margin-bottom: 15px;
    }

    .VueCarousel-slide img {
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/pages/partners.vue